interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export function Pagination({ page, totalPages, onChange }: PaginationProps) {
  return (
    <div style={{ display: 'flex', gap: 4 }}>
      <button className="pag-btn" disabled={page <= 1} onClick={() => onChange(page - 1)}>
        Anterior
      </button>
      <button className="pag-btn active" disabled>
        {totalPages > 0 ? `${page} / ${totalPages}` : page}
      </button>
      <button className="pag-btn" disabled={totalPages > 0 && page >= totalPages} onClick={() => onChange(page + 1)}>
        Siguiente
      </button>
    </div>
  );
}
